// events/notificationEvent.ts

/**
 * Defines the different types of notifications that can be displayed in the application.
 */
export enum NotificationType {
	success = 'success',
	error = 'error',
	info = 'info',
}

export const NOTIFICATION_EVENT = 'vw:notification';

export interface NotificationEventDetail {
	type: NotificationType;
	title: string;
	message: string;
}

/**
 * Dispatches a notification event.
 *
 * @param {NotificationType} type - The type of notification (success, error, info).
 * @param {string} title - The notification's title.
 * @param {string} message - The notification's message.
 */
export function dispatchNotification(type: NotificationType, title: string, message: string): void {
	document.dispatchEvent(
		new CustomEvent<NotificationEventDetail>(NOTIFICATION_EVENT, {
			detail: { type, title, message },
		}),
	);
}
